module.exports = __webpack_public_path__ + "img/what-is-web.06dc0dc9.png";